module.exports = __webpack_public_path__ + "static/media/13GalleryPuppets.0ae4a81d.jpeg";